// Asal: Abholort als eine Quelle für den ganzen Shop. Lädt Termine und Orte einmal aus dem Orangen Hub,
// füllt alle [data-asal-place] (Name, Adresse, Hinweis) und zeigt bei mehreren Orten eine Ortswahl fest im Kopf.
// Andere Skripte holen Termine über window.AsalPlace.load() – bei mehreren Orten nur die des gewählten Orts.
(() => {
  const ENDPOINT = 'https://orangen.asal-hub.de/public/pickup-slots';
  const KEY = 'asal-place';
  // Ein Abruf wird von allen Skripten geteilt, gilt aber nur 45 s (freie Plätze aktuell halten).
  // Hängt der Hub, bricht der Abruf nach 7 s ab, damit die Kasse nicht blockiert; Fehler werden nicht gemerkt.
  const TTL = 45000, TIMEOUT = 7000;
  let request = null, requestAt = 0;
  const fetchAll = () => {
    if (request && Date.now() - requestAt < TTL) return request;
    const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    const timer = ctrl ? setTimeout(() => ctrl.abort(), TIMEOUT) : null;
    requestAt = Date.now();
    const p = fetch(ENDPOINT, { cache: 'no-store', signal: ctrl ? ctrl.signal : undefined }).then(r => {
      if (!r.ok) throw new Error('Hub ' + r.status);
      return r.json();
    }).finally(() => clearTimeout(timer));
    request = p;
    p.catch(() => { if (request === p) request = null; });
    return p;
  };
  let memoryId = null;
  const storedId = () => { try { return localStorage.getItem(KEY) || memoryId; } catch (e) { return memoryId; } };
  const placesOf = days => {
    const map = new Map();
    days.forEach(d => { if (d.place && !map.has(d.place.id)) map.set(d.place.id, d.place); });
    return [...map.values()];
  };
  const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; };
  const pinSvg = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>';

  // Gemeinsame Warteschlange für ALLE Schreibvorgänge auf die Abhol-Attribute im Warenkorb (Ort, Datum, Zeit), auch aus
  // asal-abholtermin.js: streng nacheinander, damit keine verspätete Anfrage einen neueren Stand überschreibt.
  // write() liefert true/false (gespeichert?), busy() ob noch etwas läuft, idle() das Ergebnis des letzten Schreibvorgangs.
  window.AsalCartAttrs = window.AsalCartAttrs || (() => {
    let tail = Promise.resolve(true);
    let open = 0;
    return {
      write(attributes) {
        open += 1;
        const body = JSON.stringify({ attributes });
        tail = tail.then(() => fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body }).then(r => r.ok, () => false))
          .then(ok => { open -= 1; return ok; });
        return tail;
      },
      busy: () => open > 0,
      idle: () => tail,
    };
  })();

  const api = {
    load: () => fetchAll().then(({ days = [], rewards = null, stock = {} }) => {
      const places = placesOf(days);
      const place = places.find(p => String(p.id) === storedId()) || places[0] || null;
      const filtered = places.length > 1 && place ? days.filter(d => d.place && d.place.id === place.id) : days;
      return { days: filtered, all: days, places, place, rewards, stock };
    }),
    set: id => {
      try { localStorage.setItem(KEY, id); } catch (e) { /* privater Modus: Auswahl gilt nur für diese Seite */ }
      memoryId = id;
      // Ein gewählter Termin gehört zum alten Ort: zurücksetzen – über die gemeinsame Warteschlange (die Kasse wartet darauf).
      window.AsalCartAttrs.write({ Abholdatum: '', Abholzeit: '', Abholort: '', '_Abholort-ID': '' });
      apply();
      document.dispatchEvent(new CustomEvent('asal:place', { detail: { id } }));
    },
    open: () => {},
  };
  window.AsalPlace = api;

  // Auswahlfenster: je Ort eine Karte mit Adresse, nächstem Termin und freien Plätzen.
  const buildDialog = (all, places, place) => {
    const dlg = el('dialog', 'asal-placedlg');
    dlg.setAttribute('aria-label', 'Abholort wählen');
    const head = el('div', 'asal-placedlg__head');
    head.append(el('strong', '', 'Wo holst du ab?'));
    const close = el('button', 'asal-placedlg__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Schließen');
    close.addEventListener('click', () => dlg.close());
    head.append(close);
    const list = el('div', 'asal-placedlg__list');
    places.forEach(p => {
      const days = all.filter(d => d.place && d.place.id === p.id);
      const next = days.find(d => d.bookable) || days[0];
      const free = days.filter(d => d.bookable).reduce((n, d) => n + d.slots.reduce((m, s) => m + s.free, 0), 0);
      // Karte ist ein div (Rolle Schaltfläche), damit der Kartenlink darin gültig ist.
      const card = el('div', 'asal-placedlg__card' + (p.id === place.id ? ' is-current' : ''));
      card.setAttribute('role', 'button');
      card.tabIndex = 0;
      const ic = el('span', 'asal-placedlg__pin');
      ic.innerHTML = pinSvg;
      const txt = el('span', 'asal-placedlg__txt');
      txt.append(el('strong', '', p.name));
      if (p.address) txt.append(el('span', '', p.address));
      if (p.info) txt.append(el('small', '', p.info));
      const meta = el('span', 'asal-placedlg__meta');
      if (next) meta.append(el('b', '', 'Nächster Termin: ' + (d => new Date(d + 'T12:00:00').toLocaleDateString('de-DE', { weekday: 'long' }) + ', ' + new Date(d + 'T12:00:00').toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }))(next.date)));
      meta.append(el('em', '', next && next.bookable ? `${days.length} Termine · ${free} Plätze frei` : `${days.length} Termin${days.length === 1 ? '' : 'e'} · Buchung startet bald`));
      txt.append(meta);
      const map = el('a', 'asal-placedlg__map');
      map.href = p.map || 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent([p.address, p.name].filter(Boolean).join(', '));
      map.target = '_blank';
      map.rel = 'noopener';
      map.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Z"/><path d="M9 4v14M15 6v14"/></svg>';
      map.append(document.createTextNode('Auf Karte zeigen'));
      map.addEventListener('click', e => e.stopPropagation());
      txt.append(map);
      const check = el('span', 'asal-placedlg__check', p.id === place.id ? '✓' : '');
      card.append(ic, txt, check);
      const pick = () => { if (p.id === place.id) dlg.close(); else api.set(p.id); };
      card.addEventListener('click', pick);
      card.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      list.append(card);
    });
    dlg.append(head, el('p', 'asal-placedlg__hint', 'Termine, Zeitfenster und Adresse im Shop richten sich nach deinem Abholort. Du kannst ihn jederzeit ändern.'), list);
    dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
    document.body.append(dlg);
    return dlg;
  };

  const pill = place => {
    const b = el('button', 'asal-placepill');
    b.type = 'button';
    b.title = `Du holst ab in ${place.name} – Abholort ändern`;
    b.innerHTML = pinSvg;
    const t = el('span', 'asal-placepill__txt');
    t.append(el('small', '', 'Du holst ab in'), el('strong', '', place.name));
    b.append(t, el('span', 'asal-placepill__change', 'ändern'));
    b.addEventListener('click', () => api.open());
    return b;
  };

  let dlg = null;
  const apply = () => api.load().then(({ all, places, place }) => {
    if (!place) return;
    document.querySelectorAll('[data-asal-place]').forEach(node => {
      const value = place[node.dataset.asalPlace];
      if (value) node.textContent = value;
      else if (places.length > 1 && node.dataset.asalPlace === 'info') node.textContent = '';
    });
    if (places.length < 2) return;
    if (dlg) { if (dlg.open) dlg.close(); dlg.remove(); }
    dlg = buildDialog(all, places, place);
    api.open = () => (dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', ''));
    document.querySelectorAll('[data-asal-place-head], [data-asal-place-select]').forEach(slot => { slot.replaceChildren(pill(place)); slot.hidden = false; });
    // Hinweis über Terminlisten: für welchen Ort die Termine gelten
    document.querySelectorAll('[data-asal-dates], [data-asal-pdp-dates-list]').forEach(list => {
      if (list.previousElementSibling && list.previousElementSibling.classList.contains('asal-placenote')) list.previousElementSibling.remove();
      const note = el('p', 'asal-placenote');
      note.append(el('span', '', 'Termine für '), el('strong', '', place.name), el('span', '', ' · '));
      const change = el('button', '', 'Ort wechseln');
      change.type = 'button';
      change.addEventListener('click', () => api.open());
      note.append(change);
      list.before(note);
    });
  }).catch(() => { /* ohne Hub bleiben die Ersatzwerte aus den Theme-Einstellungen stehen */ });
  apply().then(() => {
    // Erster Besuch: einmal fragen, wo abgeholt wird.
    if (!storedId() && dlg) setTimeout(() => api.open(), 900);
  });
})();
